// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-title {
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 10px;
}
.content-paragraph {
  width: 100%;
  font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 28px;
  padding-bottom: 20px;
  color: var(--dark2-color);
}
.content-heading {
  color: var(--dark-color);
  margin: 20px 0px 0px 0px;
  color: var(--dark-color);
  font-size: 30px;
  font-weight: 600;
  padding: 10px 0px;
}
.content-img {
  width: 100%;
  height: 700px;
  border-radius: 8px;
  object-fit: cover;
  margin: 10px 0;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}
.content-div {
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 20px 20px 20px 20px;
  width: 90%;
  height: auto;
  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}
.content-list {
  list-style: disc;
}
.content-list li {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 28px;
}
.content-list.ordered {
  counter-reset: list-counter;
  padding-left: 0px;
}
.content-list.ordered > li {
  position: relative;
  margin: 10px 0;
  padding-left: 40px;
  list-style-type: none;
  counter-increment: list-counter;
}
.content-list.ordered > li::before {
  content: counter(list-counter) "";
  position: absolute;
  left: 0;
  top: 0;
  width: 25px;
  height: 25px;
  background-color: black;
  color: white;
  border-radius: 50%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 25px;
}
.ordered span {
  display: block;
}
.script_code {
  width: 100%;
  margin: 10px 0px;
  background: #0c0b0b;
  color: #f1f1f1;
  padding: 20px;
  border-radius: 4px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: flex;
  flex-wrap: wrap;
}
.script_code code {
  font-size: 16px;
  font-weight: 400;
}
code {
  font-family: "Outfit", sans-serif;
}
.content-list.ordered ol {
  list-style-type: lower-roman;
  margin-left: 20px;
}
.content-inner-heading {
  margin: 0;
  padding: 0;
  font-size: 20px;
  color: var(--dark2-color);
  padding-bottom: 10px;
}
.highlighted-text {
  color: white;
  background: green;
}

.subHeading {
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewDocument/DocComp.js/ContentRenderer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,6FAA6F;EAC7F,4EAA4E;AAC9E;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EAErD,aAAa;EAEb,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".step-title {\n  font-size: 44px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n.content-paragraph {\n  width: 100%;\n  font-size: 18px;\n  letter-spacing: 0.5px;\n  line-height: 28px;\n  padding-bottom: 20px;\n  color: var(--dark2-color);\n}\n.content-heading {\n  color: var(--dark-color);\n  margin: 20px 0px 0px 0px;\n  color: var(--dark-color);\n  font-size: 30px;\n  font-weight: 600;\n  padding: 10px 0px;\n}\n.content-img {\n  width: 100%;\n  height: 700px;\n  border-radius: 8px;\n  object-fit: cover;\n  margin: 10px 0;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n.content-div {\n  border-radius: 8px;\n  margin-bottom: 20px;\n  padding: 20px 20px 20px 20px;\n  width: 90%;\n  height: auto;\n  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n.content-list {\n  list-style: disc;\n}\n.content-list li {\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  line-height: 28px;\n}\n.content-list.ordered {\n  counter-reset: list-counter;\n  padding-left: 0px;\n}\n.content-list.ordered > li {\n  position: relative;\n  margin: 10px 0;\n  padding-left: 40px;\n  list-style-type: none;\n  counter-increment: list-counter;\n}\n.content-list.ordered > li::before {\n  content: counter(list-counter) \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 25px;\n  height: 25px;\n  background-color: black;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 25px;\n}\n.ordered span {\n  display: block;\n}\n.script_code {\n  width: 100%;\n  margin: 10px 0px;\n  background: #0c0b0b;\n  color: #f1f1f1;\n  padding: 20px;\n  border-radius: 4px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.script_code code {\n  font-size: 16px;\n  font-weight: 400;\n}\ncode {\n  font-family: \"Outfit\", sans-serif;\n}\n.content-list.ordered ol {\n  list-style-type: lower-roman;\n  margin-left: 20px;\n}\n.content-inner-heading {\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  color: var(--dark2-color);\n  padding-bottom: 10px;\n}\n.highlighted-text {\n  color: white;\n  background: green;\n}\n\n.subHeading {\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
